"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ZoomInSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M14.8670324,14.1667381 C15.060957,14.3611883 15.0607349,14.6759657 14.8665361,14.8701421 C14.6724022,15.0642537 14.3576745,15.0642597 14.1635331,14.8701557 L12.0195672,12.7266022 C11.0658147,13.5216752 9.83876674,14 8.5,14 C5.46243388,14 3,11.5375661 3,8.5 C3,5.46243388 5.46243388,3 8.5,3 C11.5375661,3 14,5.46243388 14,8.5 C14,9.83900614 13.5215041,11.0662536 12.7261757,12.0200789 L14.8670324,14.1667381 Z M8.5,13 C10.9852814,13 13,10.9852814 13,8.5 C13,6.01471863 10.9852814,4 8.5,4 C6.01471863,4 4,6.01471863 4,8.5 C4,10.9852814 6.01471863,13 8.5,13 Z M8,8 L8,6 L9,6 L9,8 L11,8 L11,9 L9,9 L9,11 L8,11 L8,9 L6,9 L6,8 L8,8 Z" })));
};
ZoomInSmall.displayName = 'ZoomInSmall';
exports.default = ZoomInSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ZoomInSmall.js.map